import React from "react";
import { IField } from "../../app/types";
import {
  Field,
  Dropdown,
  PasswordField,
  PrimaryButton,
  DataGridComponent,
  Date,
  ButtonGroupRenderer,
} from "./index";
import { CheckBoxComponent } from "./CheckBoxComponent";
import { GridRenderCellParams } from "@mui/x-data-grid";

/* Functional component properties */
interface Props {
  item: any;
  classes: any;
  isGridElem?: boolean;
  setWidth?: string;
  clear: string;
  isButtonGroup?: boolean;
  isGridButtonGroup?: boolean;
  setClear: (clr: string) => void;
  buttonClickHandler: (button: IField) => void;
  linkClickHandler: (link: GridRenderCellParams) => void;
}

/* React Functional component */
export const Component: React.FC<Props> = ({
  /* Function arguments (Props) */
  item,
  classes,
  isGridElem,
  setWidth,
  clear,
  setClear,
  isButtonGroup,
  isGridButtonGroup,
  buttonClickHandler,
  linkClickHandler,
}): JSX.Element => {
  return (() => {
    switch (
      isButtonGroup
        ? "buttonGroup"
        : // : isGridButtonGroup
        // ? "gridButtonGroup"
        isGridElem
        ? item.colDef.type
        : item.rowCount !== undefined
        ? "grid"
        : item.type
    ) {
      case "integer":
      case "string":
        if (item.name === "PASSWORD")
          return (
            <PasswordField
              key={item.name}
              classes={classes}
              item={item}
              isGridElem={isGridElem || false}
              setWidth={setWidth || "true"}
              clear={clear}
              setClear={setClear}
            />
          );
        else
          return (
            <Field
              key={item.name}
              classes={classes}
              item={item}
              isGridElem={isGridElem || false}
              setWidth={setWidth || "true"}
              clear={clear}
              setClear={setClear}
              handler={linkClickHandler}
              buttonClickHandler={buttonClickHandler}
            />
          );

      case "boolean":
        return (
          <CheckBoxComponent
            classes={classes}
            item={item}
            isGridElem={isGridElem || false}
            setWidth={setWidth || "true"}
            clear={clear}
            setClear={setClear}
          />
        );

      case "ddl":
        return (
          <Dropdown
            key={item.name}
            classes={classes}
            item={item}
            isGridElem={isGridElem || false}
            setWidth={setWidth || "true"}
            clear={clear}
            setClear={setClear}
          />
        );

      case "button":
        return (
          <PrimaryButton
            key={item.name}
            item={item}
            classes={classes}
            handler={buttonClickHandler}
            setClear={setClear}
          ></PrimaryButton>
        );

      case "buttonGroup":
        return (
          <ButtonGroupRenderer
            key={item.name}
            items={item}
            classes={classes}
            handler={buttonClickHandler}
            setClear={setClear}
          ></ButtonGroupRenderer>
        );

      // case "gridButtonGroup":
      //   return (
      //     <GridComponent
      //       classes={classes}
      //       item={item}
      //       clear={clear}
      //       setClear={setClear}
      //       buttonClickHandler={buttonClickHandler}
      //       linkClickHandler={linkClickHandler}
      //     ></GridComponent>
      //   );

      case "grid":
        return (
          <DataGridComponent
            key={item.name + "DataGridComponent"}
            item={item}
            classes={classes}
            clear={clear}
            setClear={setClear}
            buttonClickHandler={buttonClickHandler}
            linkClickHandler={linkClickHandler}
          ></DataGridComponent>
        );

      case "date":
        return (
          <Date
            key={item.name}
            classes={classes}
            item={item}
            isGridElem={isGridElem || false}
            setWidth={setWidth || "true"}
            clear={clear}
            setClear={setClear}
          />
        );

      default:
        console.log("Item could not render", item);
        return <div>To work upon component type: {item.name}</div>;
    }
  })();
};
